import template from './alert.html';
import controller from './alert.controller.js';
import './alert.scss';

let alertComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default alertComponent;
